import React from 'react';
export function ScienceSection() {
  return <section className="bg-white py-20" data-id="element-125">
      <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row md:items-stretch items-center gap-12" data-id="element-126">
        <div className="w-full md:w-1/2 flex" data-id="element-127">
          <img src="https://cdn.magicpatterns.com/uploads/7TdiyMcMF9tvy5SXGXKobN/ChatGPT_Image_22_may_2026,_09_48_55_p.m..png" alt="Mujer despierta en la cama mirando su teléfono de noche" className="w-full h-full max-h-[700px] rounded-2xl shadow-xl object-cover" data-id="element-128" />
        </div>

        <div className="w-full md:w-1/2 space-y-8" data-id="element-129">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-text" data-id="element-130">
            La ciencia detrás del sueño roto
          </h2>

          <div className="space-y-4 text-lg text-gray" data-id="element-131">
            <p className="font-bold text-text" data-id="element-132">
              Tu problema no es insomnio. Es cortisol nocturno elevado.
            </p>
            <p data-id="element-133">
              Cuando el cortisol no baja de noche, tu cerebro no puede entrar en
              sueño profundo — sin importar cuántas horas estés en cama.
            </p>
            <p data-id="element-134">
              El Código del Sueño Profundo ataca la causa raíz: regula el
              cortisol, sincroniza tu ritmo circadiano y prepara tu sistema
              nervioso para descansar de verdad.
            </p>
          </div>

          <div className="space-y-4 pt-4" data-id="element-135">
            <div className="bg-accent/20 p-5 rounded-xl border border-accent/30" data-id="element-136">
              <p className="font-medium text-secondary" data-id="element-137">
                <span className="mr-2" data-id="element-138">🔬</span> El cortisol elevado de noche
                reduce el sueño profundo hasta un 40%
              </p>
            </div>
            <div className="bg-accent/20 p-5 rounded-xl border border-accent/30" data-id="element-139">
              <p className="font-medium text-secondary" data-id="element-140">
                <span className="mr-2" data-id="element-141">🌙</span> La luz azul suprime la
                melatonina hasta un 50% en adultos
              </p>
            </div>
            <div className="bg-accent/20 p-5 rounded-xl border border-accent/30" data-id="element-142">
              <p className="font-medium text-secondary" data-id="element-143">
                <span className="mr-2" data-id="element-144">⏰</span> Un horario consistente
                sincroniza el ritmo circadiano en solo 7 días
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}